'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _options = require('../common/options');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FunnelComponent = function (_BaseComponent) {
    (0, _inherits3.default)(FunnelComponent, _BaseComponent);

    function FunnelComponent(props) {
        (0, _classCallCheck3.default)(this, FunnelComponent);
        return (0, _possibleConstructorReturn3.default)(this, (FunnelComponent.__proto__ || (0, _getPrototypeOf2.default)(FunnelComponent)).call(this, props));
    }

    /**
     * 矫正 option
     */


    (0, _createClass3.default)(FunnelComponent, [{
        key: 'packageOption',
        value: function packageOption() {
            var _this2 = this;

            var option = JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _options.FunnelOption)));
            var _props = this.props,
                type = _props.type,
                color = _props.color,
                title = _props.title,
                subTitle = _props.subTitle,
                _props$titleX = _props.titleX,
                titleX = _props$titleX === undefined ? 'left' : _props$titleX,
                _props$orient = _props.orient,
                orient = _props$orient === undefined ? 'horizontal' : _props$orient,
                _props$legendY = _props.legendY,
                legendY = _props$legendY === undefined ? 'auto' : _props$legendY,
                _props$legendX = _props.legendX,
                legendX = _props$legendX === undefined ? 'center' : _props$legendX,
                min = _props.min,
                max = _props.max,
                hasLegend = _props.hasLegend,
                hasToolbox = _props.hasToolbox,
                hasTooltip = _props.hasTooltip,
                animation = _props.animation,
                data = _props.data;

            var legendData = [];
            var xData = [];
            var series = [];
            if (color && color.length) {
                option.color = color;
            }
            option.title.text = title;
            option.title.subtext = subTitle;
            option.title.x = titleX;
            option.tooltip.show = hasTooltip;
            option.legend.show = hasLegend;
            option.legend.bottom = legendY;
            option.legend.x = legendX;
            option.legend.orient = orient;
            option.toolbox.show = hasToolbox;
            option.animation = animation;

            // 设置 series
            if (Object.prototype.toString.call(data) === '[object Array]' && data.length) {
                data.forEach(function (obj) {
                    xData = [];
                    _this2.collectionSeries(obj, series, legendData, xData);
                });
            } else if (Object.prototype.toString.call(data) === '[object Object]') {
                this.collectionSeries(data, series, legendData, xData);
            }
            option.legend.data = legendData;
            option.series = series;

            return option;
        }

        /**
         * 
         * 收集 series
         */

    }, {
        key: 'collectionSeries',
        value: function collectionSeries(data, series, legendData, xData) {
            var _props2 = this.props,
                type = _props2.type,
                min = _props2.min,
                max = _props2.max,
                funnelAlign = _props2.funnelAlign,
                _props2$padding = _props2.padding,
                padding = _props2$padding === undefined ? { top: 60, bottom: 60 } : _props2$padding;

            if (data.data && data.data.length) {
                data.data.forEach(function (item) {
                    legendData.push(item.name);
                });
            }
            series.push({
                name: data.name,
                type: 'funnel',
                left: '10%',
                top: padding.top,
                bottom: padding.bottom,
                width: '80%',
                minSize: '0%',
                maxSize: '100%',
                sort: 'descending',
                funnelAlign: funnelAlign,
                gap: 2,
                label: {
                    normal: {
                        show: true,
                        position: 'inside'
                    },
                    emphasis: {
                        textStyle: {
                            fontSize: 20
                        }
                    }
                },
                labelLine: {
                    normal: {
                        length: 10,
                        lineStyle: {
                            width: 1,
                            type: 'solid'
                        }
                    }
                },
                itemStyle: {
                    normal: {
                        borderColor: '#fff',
                        borderWidth: 1
                    }
                },
                data: data.data,
                min: min,
                max: max
            });
        }
    }]);
    return FunnelComponent;
}(_Base2.default);

exports.default = FunnelComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Funnel.js
// module id = 608
// module chunks = 0